import { profileTypeEndPoint, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import { transformData } from "@helpers/profileHelper";
import { toast } from "react-toastify";
import ProfileHeader from "@components/templates/Profile/ProfileHeader";
import { useSelector } from "react-redux";
import { profileDetailsInfo } from "@containers/CompanyProfile/utils/enum.js";
import * as Sentry from "@sentry/browser";
import { profileType } from "@utils/enum";

const Header = ({ isSalesForce, setIsProfileViewExhaust, isProfileViewExhaust, isStarterPlan }) => {
  const { companyID, companyname } = useParams();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [profileDetails, setProfileDetails] = useState({});
  const [copyText, setCopyText] = useState([]);
  const [copyTextPill] = useState([]);
  const [profileId, setProfileId] = useState(null);
  const { search: searchUrlParams } = useLocation();
  const { isParentSubs } = useSelector((state) => state.companyProfile);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";

  const generateCopyTextArr = (data) => {
    return [
      { key: profileDetailsInfo.naics_code, label: transformData(data.naics_code, false, false), isCopy: false },
      { key: profileDetailsInfo.sic_code, label: transformData(data.sic_code, false, false), isWebsite: false, isCopy: false },
      { key: profileDetailsInfo.lei_code, label: transformData(data.lei_code, false, true), isCopy: false },
      { key: profileDetailsInfo.tickers, label: transformData(data.tickers?.ticker_name?.[0], false, false), isWebsite: false, isCopy: false, tooltipLabel: data.tickers?.exchange_name?.[0] },
      { key: profileDetailsInfo.revenue, label: transformData(data.revenue, false, false), isCopy: false },
      { key: profileDetailsInfo.scac_code, label: transformData(data.scac_code, false, false), isWebsite: false, isCopy: false },
      { key: profileDetailsInfo.ruc, label: transformData(data.ruc, false, false), isWebsite: false, isCopy: false },
      { key: profileDetailsInfo.websites, label: data.websites?.length ? data.websites : "", isWebsite: true, isCopy: false },
    ].filter((item) => item.label);
  };

  useEffect(() => {
    let isMerged = new URLSearchParams(searchUrlParams).get("isMerged");
    let mergeId = new URLSearchParams(searchUrlParams).get("mergedID");
    const requestPayload = {
      profile_type: profileTypeEnum.company,
      _id: companyID,
      isSubsidiaryIncluded: isParentSubs,
      slug: companyname,
    };
    if (mergeId) {
      requestPayload.isMerged = isMerged === "false" ? false : true;
      requestPayload.mergedID = +mergeId;
    }
    axios
      .post(profileTypeEndPoint.ports.getProfileHeaderDetails, requestPayload)
      .then((res) => {
        const { data } = res.data;
        const transFormResponse = {
          ...data,
          name: transformData(data.name, true, false),
          state: transformData(data.state, true, false),
          country: transformData(data.country, true, false),
          countryCode: transformData(data.country_code, false, true),
          address: transformData(data.address, true, false),
          companyName: data.name,
          profileViewsStarter: {
            maxAllowed: res.data.profile_starter_max_count,
            currCount: res.data.profile_starter_current_count,
          },
        };
        if (res?.data?.profile_starter_max_count - res?.data?.profile_starter_current_count <= 0 && STARTERPLAN) {
          setIsProfileViewExhaust(true);
        } else {
          setIsProfileViewExhaust(false);
        }
        setProfileDetails(transFormResponse);
        setCopyText(generateCopyTextArr(data));
        setProfileId(data?.elastic_data_id?.[0]);
      })
      .catch((err) => {
        setError(true);
        Sentry.captureException(err);
        toast.error("Something went wrong. Please try again later !!!");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [companyID, isParentSubs]);

  return <ProfileHeader isSalesForce={isSalesForce} profileId={profileId} profileType={profileType.company} showFavourites={true} loading={loading} error={error} profileDetails={profileDetails} copyText={copyText} copyTextPill={copyTextPill} showProfilePill={false} isStarterPlan={isStarterPlan} isProfileViewExhaust={isProfileViewExhaust} />;
};

export default Header;
